<template>
  <EditorPickLotteryPickerSection data-containerid="pick_lottery_editor_bet_type">
    <template #headline>{{ $t('picklottery.bettype.label') }}</template>

    <LcFormField class="flex flex-col gap-200" v-slot="{ field }" name="addOn">
      <LcSelect
        v-bind="field"
        :options="betTypeOptions"
        :label="$t('picklottery.bettype.label')"
        :value="selectedPerPlayAddOn"
        no-feedback
        no-teleport
        not-nullable
        @update:value="handleSetPerPlayAddOn"
      />

      <p v-if="selectedPerPlayAddOn">
        {{ $t(`lottery.bettype.${selectedPerPlayAddOn}.explanation`) }}
      </p>
    </LcFormField>
  </EditorPickLotteryPickerSection>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config } from '../@types/editor'

import { type EditorPlay, usePickLotteryStore } from '../stores/pickLottery'

type Props = {
  config: Config
  lotteryId: LotteryId
  play: EditorPlay
}

const { config, lotteryId, play } = defineProps<Props>()

const { getPerPlayTranslation } = useTranslations()
const { setPerPlayAddOn } = usePickLotteryStore(lotteryId)

const betTypeOptions = computed(() => {
  const addOn = perPlayAddOn.value
  if (!addOn) return []

  return addOn.options.map((value) => ({
    label: getPerPlayTranslation(lotteryId, addOn.name, value),
    value,
  }))
})

const perPlayAddOn = computed(() => (config.addOns ?? []).find(({ perPlay }) => perPlay))

const selectedPerPlayAddOn = computed(() => play.perPlayAddOn?.value ?? null)

const handleSetPerPlayAddOn = (value?: Maybe<number | string>) => {
  const name = perPlayAddOn.value?.name
  if (!name || !value) return
  setPerPlayAddOn(play.id, { name, value: String(value) }, config)
}
</script>
